import classNames from "classnames";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import { useParams } from "react-router-dom";
interface IMilestoneHeaderProps {
  complexContractTitle: string;
  currentStep: number;
  buyerOnly?: boolean;
}

const MilestoneHeader = ({
  complexContractTitle,
  currentStep,
  buyerOnly,
}: IMilestoneHeaderProps) => {
  const { t } = useTranslation();
  const { complexId, milestoneId } = useParams();
  const isEditMode = !!complexId && !!milestoneId;
  return (
    <div className={styles.container}>
      <p className={styles.titleSm}>{complexContractTitle}</p>
      <h2 className={styles.titleLg}>
        {isEditMode ? t("EDIT_TRANSACTION_SAFE") : t("lbl_add_transaction")}
      </h2>

      <div className={styles.steps}>
        <div className={styles.stepRow}>
          <div
            className={`${styles.circle} ${
              currentStep === 1 ? styles.circleActive : ""
            }`}>
            <div
              className={classNames(styles.check, {
                [styles.done]: currentStep > 1,
              })}
            />
          </div>
          <p className={styles.stepLabel}>{t("lbl_transaction_data")}</p>
        </div>
        <div className={styles.divider} />
        <div className={styles.stepRow}>
          <div
            className={`${styles.circle} ${
              currentStep === 2 ? styles.circleActive : ""
            }`}>
            <div
              className={classNames(styles.check, {
                [styles.done]: currentStep > 2,
              })}
            />
          </div>
          <p className={styles.stepLabel}>{t("lbl_payees")}</p>
        </div>
        {!buyerOnly && (
          <>
            <div className={styles.divider} />
            <div className={styles.stepRow}>
              <div
                className={`${styles.circle} ${
                  currentStep === 3 ? styles.circleActive : ""
                }`}>
                <div
                  className={classNames(styles.check, {
                    [styles.done]: currentStep > 3,
                  })}
                />
              </div>
              <p className={styles.stepLabel}>{t("lbl_receivers")}</p>
            </div>
          </>
        )}
        <div className={styles.divider} />
        <div className={styles.stepRow}>
          <div
            className={`${styles.circle} ${
              currentStep === 4 ? styles.circleActive : ""
            }`}>
            <div
              className={classNames(styles.check, {
                [styles.done]: currentStep > 4,
              })}
            />
          </div>
          <p className={styles.stepLabel}>{t("lbl_terms_and_conditions")}</p>
        </div>
      </div>
    </div>
  );
};

export default MilestoneHeader;
